@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.drop-down-header {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  height: 36px;
  border-bottom: 1px solid @app-header--help-menu-dropdown--border-color;
  background: @app-header--help-menu-dropdown--background-color;
  font-size: 13px;
}

.header-name {
  .truncate();
  line-height: 36px;
  padding-right: 10px;
  color: @app-header--help-menu-dropdown--text-color;
}

.help-menu-dropdown {
  width: 100%;
  height: 100%;
}

.suppport-dropdown-menu {
  max-height: 565px;

  a {
    color: @app-header--help-menu-dropdown--text-color;
  }
}

.help-menu-dropdown-toggler {
  height: 100%;
  width: 100%;
}

.help-menu-dropdown-toggler-content {
  height: 100%;
  min-width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}

.holiday-item {
  max-width: 300px;
  padding: 15px;
}
